var active=false;
var warnCoupon = false;

$(function(){
  if ($('#clock').length > 0){
    var countdown = Tock({
      countdown: true,
      callback: function () {
        $('#clock').html(countdown.msToTime(countdown.lap()).substring(0, 5));
      },
      complete: function () {
        var myHeight=($( window ).height()-$('.reservedPopupTime').height())/2;
        active=true;
        $('.reservedPopupTime').css("top",myHeight);
        openCover();
        $('.modal').remove();
        $('.modal-backdrop').remove();
      }
    });
    countdown.start($('#clock').data('time'));
  }

  $('.btn-coupon').on('click', function(e){
    var that = $(this),
    input = $('input[name="code"]');

    if (input.val() == '') {
      return;
    }

    $.ajax({
      url: input.data('action'),
      type: 'post',
      dataType: 'json',
      data: {
        code: input.val()
      },
    })
    .done(function(data) {
      if (data.success){
        dealCoupon(data.message, 'alert-success');
        setTimeout(function() {
          window.location.reload();
        }, 1000);
      }
      else{
        dealCoupon(data.message, 'alert-error');
        $('input[name="code"]').addClass('parsley-error');
        $('.code-label').css('color', '#d50000');
        $('input[name="accept"]').prop('checked', false);
        $('.btn-proceed').attr('disabled', 'disabled');
        warnCoupon = true;
      }
    })
    .fail(function(data) {
      dealCoupon('', 'alert-error');
    });
  });

  function dealCoupon(message, classy){
    $('.code-msg').hide().text('');
    $('.code-msg.' + classy).show().text(message);
  }

  $('input[name="billing"][type="radio"]').on('change', function(){
    var that = $(this);
    if (that.val() == 1){
      $('.billinginfos').css({'opacity': '0.5'}).find('input').attr('disabled', 'disabled').css({'opacity': '0.5'});
    }
    else{
      $('.billinginfos').css({'opacity': '1'}).find('input').removeAttr('disabled').css({'opacity': '1'});
    }
  });
   if ($('input[name="billing"][type="radio"]').val() == 1){
      $('.billinginfos').css({'opacity': '0.5'}).find('input').attr('disabled', 'disabled').css({'opacity': '0.5'});
    }
    else{
      $('.billinginfos').css({'opacity': '1'}).find('input').removeAttr('disabled').css({'opacity': '1'});
    }
});

$(window).resize(function() {
  if(active==true){
    myHeight=($( window ).height()-$('.reservedPopupTime').height())/2;
    $('.reservedPopupTime').css("top",myHeight);
  }
});

function openCover(){
  $('.coverScreen').css("display", "block");
  setTimeout(function() {
    $('.coverScreen').css("opacity", "1");
  }, 50);
}

$('#completeReturn').click(function(){
  location.reload();
});

$('#contractAccept').change(function() {
  if ($(this).is(':checked')) {
     $('.infoPerso .btn-proceed').attr('disabled', false);
  } else {
    $('.infoPerso .btn-proceed').attr('disabled', true);
  }
});

$('.btn-pay').submit(function(){
   $(this).find('input[type=submit]').attr('disabled', 'disabled');
});

$('.cart-step2 .btn-proceed').on('click', function(e){
  if (warnCoupon) {
    $('#warnCouponModal').modal();
  }
  else {
    $('.cart-step2').submit();
  }
});

$('.cart-step2 #warnCouponModalCancel').on('click', function(e){
  $('#warnCouponModal').modal('hide');
});

$('.cart-step2 #warnCouponModalGo').on('click', function(e){
  $('.cart-step2').submit();
});
